import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;
function DespachoColaborador() {
    const { loading, setLoading } = useContext(ContextGloball);
    const [sucursales, setSucursales] = useState([]);
    const [idSucursal, setIdSucursal] = useState(0);
    const [datos, setDatos] = useState([]);
    const [fecha, setFecha] = useState('');
    function obtenerSucursales() {
        if (sucursales.length == 0) {
            setLoading(true);
            fetch(`${server}/sqlComun/getSucursales`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': JSON.parse(localStorage.getItem('__react_session__')).regional
                })
            })
                .then(res => res.json())
                .then(data => {
                    setLoading(false);
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {
                        setSucursales(data.ok)
                    }
                })
                .catch(error => MsgUtils.msgError(error));
        }
    }
    function obtenerInformacion() {
        if (idSucursal !== 0 && fecha != '') {
            setLoading(true);
            var sucursalS = sucursales.filter((item) => item.ID_SUCURSAL == idSucursal)[0]
            fetch(`${server}/reporte/obtenerDespachoColaborador`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...sucursalS, fecha,
                    'regional': JSON.parse(localStorage.getItem('__react_session__')).regional,
                    'idEmpleado': JSON.parse(localStorage.getItem('info')).ID_EMPLEADO,
                })
            })
                .then(res => res.json())
                .then(data => {
                    setLoading(false);
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {
                        setDatos(data.ok);
                        console.log(data);
                    }
                })
                .catch(error => MsgUtils.msgError(error));
        } else {
            MsgUtils.msgError("Elija sucursal y fecha por favor")
        }
    }
    function obtenerSumatoria(columna) {
        var lista = datos.map((item)=>Object.values(item)[columna]);
        var sumatoria = lista.reduce((a, b) => a + b, 0);
        return sumatoria
    }
    function getTotalColaborador(datos){
        var lista=Object.values(datos);
        lista.shift()
        lista.shift()
        var sumatoria = lista.reduce((a, b) => a + b, 0);
        return sumatoria
    }
    useEffect(() => {
        obtenerSucursales()
    }, [])
    return (
        <>
            <div className='container-fluid bg-dark bg-gradient py-1'>
                <div className='row row-cols gx-1'>
                    <div className='col' style={{ maxWidth: '190px' }}>
                        <div className="input-group input-group-sm" >
                            <span className="text-light mx-1 my-auto" >Sucursal</span>
                            <select className="form-select" title='Seleccione el producto'
                                value={idSucursal} onChange={(e) => setIdSucursal(e.target.value)}
                            >
                                <option value={0}>Ninguno</option>
                                {sucursales.map((item, index) => {
                                    return (
                                        <option value={item.ID_SUCURSAL} key={index}>{item.SUCURSAL}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '180px' }}>
                        <div className="input-group input-group-sm" >
                            <span className="text-light mx-1 my-auto" >Fecha</span>
                            <input type='date' value={fecha}
                                className='form-control' title='Elija la fecha'
                                onChange={(e) => setFecha(e.target.value)}></input>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '100px' }}>
                        <button className='btn btn-sm btnNaranja w-100' onClick={() => obtenerInformacion()}>
                            <i className="fa-solid fa-magnifying-glass"></i> Buscar
                        </button>
                    </div>
                </div>
            </div>
            {datos.length==0&&<div className='container-fluid bg-warning text-center text-dark'>No se tiene información</div>}
            <div className='table-responsive'>
                <table className="table table-sm table-dark table-sm table-striped table-hover table-bordered border-secondary">
                    <thead>
                        <tr className='text-center'>
                            <th>Colaborador</th>
                            <th>Pedidos</th>
                            <th>Cuato Pollo</th>
                            <th>Medio Pollo</th>
                            <th>Queen Menu</th>
                            <th>King Menu</th>
                            <th>Solo Cuarto</th>
                            <th>Solo Medio</th>
                            <th>Solo Pipoca</th>
                            <th>Pipocas</th>
                            <th>Combo Pipoca</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {datos.map((item, index) => {
                            return (
                                <tr key={index} className='text-center'>
                                    <th className='text-start'>{item.NOMBREX}</th>
                                    <td>{item.PEDIDOS}</td>
                                    <td>{item.MENU1}</td>
                                    <td>{item.MENU2}</td>
                                    <td>{item.MENU3}</td>
                                    <td>{item.MENU4}</td>
                                    <td>{item.MENU5}</td>
                                    <td>{item.MENU6}</td>
                                    <td>{item.MENU28}</td>
                                    <td>{item.MENU29}</td>
                                    <td>{item.MENU30}</td>
                                    <td>{getTotalColaborador(item)}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                    {datos.length!=0&&<tfoot>
                        <tr className='text-center'>
                            <th className='text-start'></th>
                            <td>{obtenerSumatoria(2)}</td>
                            <td>{obtenerSumatoria(3)}</td>
                            <td>{obtenerSumatoria(4)}</td>
                            <td>{obtenerSumatoria(5)}</td>
                            <td>{obtenerSumatoria(6)}</td>
                            <td>{obtenerSumatoria(7)}</td>
                            <td>{obtenerSumatoria(8)}</td>
                            <td>{obtenerSumatoria(9)}</td>
                            <td>{obtenerSumatoria(10)}</td>
                            <td>{obtenerSumatoria(11)}</td>
                        </tr>
                    </tfoot>}
                </table>
            </div>
        </>
    )
}

export default DespachoColaborador